import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("koi_token");
    const u = localStorage.getItem("koi_user");
    if (t && u) {
      try { setUser(JSON.parse(u)); } catch { /* noop */ }
    }
    setReady(true);
  }, []);

  const login = useCallback((token, u) => {
    localStorage.setItem("koi_token", token);
    localStorage.setItem("koi_user", JSON.stringify(u));
    setUser(u);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("koi_token");
    localStorage.removeItem("koi_user");
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      localStorage.setItem("koi_user", JSON.stringify(data));
      setUser(data);
    } catch {
      /* noop */
    }
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
